export enum Acr {
  MID = 'mid',
  MID_EE = 'mid_ee',
  MID_LT = 'mid_lt',
  SID = 'sid',
  SID_EE = 'sid_ee',
  SID_LV = 'sid_lv',
  SID_LT = 'sid_lt',
  SID_BE = 'sid_be',
  IDCARD = 'idcard',
  IDCARD_EE = 'idcard_ee',
  EPARAKSTS = 'eparaksts',
  EIDAS_LOA_HIGH = 'http://eidas.europa.eu/LoA/high',
  EIDAS_LOA_SUBSTANTIAL = 'http://eidas.europa.eu/LoA/substantial',
}

const AcrCountries = {
  [Acr.MID]: ['EE', 'LT'],
  [Acr.MID_EE]: ['EE'],
  [Acr.MID_LT]: ['LT'],
  [Acr.SID]: ['EE', 'LV', 'LT', 'BE'],
  [Acr.SID_EE]: ['EE'],
  [Acr.SID_LV]: ['LV'],
  [Acr.SID_LT]: ['LT'],
  [Acr.SID_BE]: ['BE'],
  [Acr.IDCARD]: ['EE'],
  [Acr.IDCARD_EE]: ['EE'],
  [Acr.EPARAKSTS]: ['LV'],
  [Acr.EIDAS_LOA_HIGH]: ['EE', 'LV', 'LT', 'BE'],
  [Acr.EIDAS_LOA_SUBSTANTIAL]: [],
};

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Acr {
  export function fromString(acr: string): Acr | undefined {
    const lower = acr.toLowerCase();
    for (const key in Acr) {
      const value = Acr[key as keyof typeof Acr];
      if (typeof value === 'string' && value.toLowerCase() === lower) {
        return value as Acr;
      }
    }
    return undefined;
  }

  export function getCountries(acrStr: string) {
    const acr = fromString(acrStr);
    return acr ? AcrCountries[acr] : [];
  }

  export function getParentAcr(acr?: Acr) {
    switch (acr) {
      case Acr.MID_EE:
      case Acr.MID_LT:
        return Acr.MID;
      case Acr.SID_EE:
      case Acr.SID_LV:
      case Acr.SID_LT:
      case Acr.SID_BE:
        return Acr.SID;
      case Acr.IDCARD_EE:
        return Acr.IDCARD;
      default:
        return acr;
    }
  }
}
